import { Component } from '@angular/core';


@Component({
    selector: 'modal-footer',
    styles: [
        `
        :host {
            display: flex;
            background: white;
            align-items: center;
            justify-content: space-between;
            padding: 1rem;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            border-bottom-left-radius: 0.3rem;
            border-bottom-right-radius: 0.3rem;
        }
        :host ::ng-deep .btn {
            min-width: 4em;
        }
        :host ::ng-deep .btn:not(:first-child) {
            margin-left: 0.4rem;
        }
        :host ::ng-deep .btn:not(:last-child) {
            margin-right: 0.4rem;
        }
        `
    ],
    template: `
        <ng-content></ng-content>
    `,
})
export class ModalFooterComponent {}
